<script setup lang="ts">
import { SellingMethod, getApiAuctionDetailQueryKey, useApiAuctionDetail } from '~/apiClient';
import { AUCTION_DETAIL_QUERY_KEY_PREFIX } from '~/constants/queryKeyPrefix';

definePageMeta({
    key: route => `auction-detail-static-${route.params.slug}`, // Prevent full page re-rendering on locale change
});

// COMPOSABLES
const { id } = useSdpParams();
const { trackViewSale } = useTracking();

// DATA
const {
    data: auction,
    error,
    isError,
    suspense,
    refetch,
} = useApiAuctionDetail(id, {
    query: {
        queryKey: [AUCTION_DETAIL_QUERY_KEY_PREFIX, ...getApiAuctionDetailQueryKey(id)],
    },
});

// Perform await only if the id is correct resolved to the path
!!id.value && (await suspense());

const { sale } = useSale(auction, SellingMethod.Auction);
useSdpParamsChecker(sale, error, isError);

// LIFECYCLE
onMounted(() => {
    sale.value && trackViewSale(sale.value);
});
</script>
<template>
    <Sdp v-if="sale" :sale="sale" @refetch="refetch" />
</template>
